import { render, staticRenderFns } from "./SetPromotionOne.vue?vue&type=template&id=1746fbbb&scoped=true"
import script from "./SetPromotionOne.vue?vue&type=script&lang=js"
export * from "./SetPromotionOne.vue?vue&type=script&lang=js"
import style0 from "./SetPromotionOne.vue?vue&type=style&index=0&id=1746fbbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746fbbb",
  null
  
)

export default component.exports